import { Box, ScrollArea, Space, Stack, Text } from '@mantine/core';
import { any } from 'lodash/fp';
import React, { useMemo } from 'react';

import { OrderType } from '@portals/api/partners';
import { useGenericContext } from '@portals/framework';

import { OrderProductBreakdownRow } from './OrderProductBreakdownRow';

interface OrderProductsBreakdownProps {
  onSelectPurchasedProductId: (purchasedProductId: string) => void;
  selectedPurchasedProductId: string | null;
}

export function OrderProductsBreakdown({
  onSelectPurchasedProductId,
  selectedPurchasedProductId,
}: OrderProductsBreakdownProps) {
  const order = useGenericContext<OrderType>();

  const withSerialNumber = useMemo(
    () =>
      any(
        (purchasedProduct: OrderType['purchased_products'][number]) =>
          Boolean(purchasedProduct.sn),
        order?.purchased_products
      ),
    [order?.purchased_products]
  );

  return (
    <Stack spacing={0}>
      <Box
        px="xs"
        pb="xs"
        sx={(theme) => ({
          display: 'grid',
          gridTemplateColumns: withSerialNumber
            ? '2fr 1.5fr 1.5fr 1.5fr 100px'
            : '2fr 1.5fr 1.5fr 100px',
          borderBottom: `1px solid ${theme.colors.gray[2]}`,
          gap: theme.spacing.sm,
        })}
      >
        <Text>Name</Text>
        <Text>Model</Text>
        {withSerialNumber ? <Text>Serial Number</Text> : null}
        <Text>Price</Text>

        <Box sx={{ width: '100px' }} />
      </Box>

      <ScrollArea.Autosize mah={430}>
        {(order?.purchased_products || []).map(({ id, order_item_id, sn }) => (
          <OrderProductBreakdownRow
            key={id}
            orderItemId={order_item_id}
            onSelect={() => onSelectPurchasedProductId(id)}
            isSelected={selectedPurchasedProductId === id}
            withSerialNumber={withSerialNumber}
            sn={sn}
          />
        ))}

        <Space h="xs" />
      </ScrollArea.Autosize>
    </Stack>
  );
}
